/**
 * TableSemanticSchema registry — the 17 enriched schemas share this
 * runtime slot so the table renderer, agent extraction tools, and the
 * property panel can look up typed metadata by id.
 *
 * This registry is separate from the visual schema registry at
 * `src/domains/diagram/shapes/table/tableSchemas.registry.ts`. Both
 * registries key off the same schema id (e.g. `'swot'`) so visual and
 * semantic overlays bind 1:1.
 */

import type { TableSemanticSchema } from './types';

const SCHEMAS = new Map<string, TableSemanticSchema>();

export function registerTableSemanticSchema(schema: TableSemanticSchema): void {
  SCHEMAS.set(schema.id, schema);
}

export function getTableSemanticSchema(id: string): TableSemanticSchema | undefined {
  return SCHEMAS.get(id);
}

export function listTableSemanticSchemas(): TableSemanticSchema[] {
  return Array.from(SCHEMAS.values());
}

export function clearTableSemanticSchemas(): void {
  SCHEMAS.clear();
}
